// @ts-nocheck
import { BaseModel } from "../../core/models";
import { type GetLensSourceListEnabledQuery } from "../api/queries";
import { LensSourcesDomainModel } from "./LensSourcesDomainModel";
import { SourcesByType } from "./SourcesByType";

type QueryType = GetLensSourceListEnabledQuery["getLensSourceListEnabled"]["lensSourceMap"];

export class LensSourcesOperations {
    public static createFromQuery(sourceTypes: QueryType): LensSourcesDomainModel {
        const allSourcesGrouped = sourceTypes.reduce<SourcesByType[]>((prev, current) => {
            return [
                ...prev,
                BaseModel.createInstance(SourcesByType, {
                    type: current.lensSourceType,
                    sources: [...current.lensSourceList],
                }),
            ];
        }, []);

        return BaseModel.createInstance(LensSourcesDomainModel, {
            allSourcesGrouped,
            filteredAllSourcesGrouped: allSourcesGrouped,
        });
    }
}
